module.exports = __webpack_public_path__ + "static/media/SofiaProExtraLightItalic.36ddf111.otf";